import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchSavedJobs, saveJobApi } from "./SavedJobsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchSavedJobsAsync = createAsyncThunk(
  "SavedJobs/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchSavedJobs();

      const resp = data.response.data;
      // console.log("data's response", data.response);
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateBookmarkAsync = createAsyncThunk(
  "SavedJobs/update",
  async ({ job_uuid, status }, { rejectWithValue }) => {
    try {
      // console.log("slice uuid", job_uuid)
      const response = await saveJobApi( job_uuid, status );

      if (!response || !response.job_uuid) {
        throw new Error("Invalid response from API");
      }

      return { uuid: response.job_uuid }; // Adjust according to your API response
    } catch (error) {
      console.error("Failed to update bookmark:", error);
      return rejectWithValue(error.message);
    }
  }
);

const SavedJobsSlice = createSlice({
  name: "SavedJobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSavedJobsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSavedJobsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchSavedJobsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })

      .addCase(updateBookmarkAsync.fulfilled, (state, action) => {
        const { job_uuid, status } = action.payload;

        if (status === 'save') {
          state.push(job_uuid);
          console.log("job_uuid", job_uuid)
        } else if (status === 'remove') {
          return state.filter((jobUuid) => jobUuid !== job_uuid);
        }
      })
      .addCase(updateBookmarkAsync.rejected, (state, action) => {
        console.error('Failed to update bookmark:', action.payload);
      });

    // .addCase(saveJobAsync.fulfilled, (state, action) => {
    //   state.loading = false;
    //   if (Array.isArray(state.data)) {
    //     state.data?.push(action.payload);
    //   } else {
    //     state.data = [action.payload]; // Initialize as an array if it's not already
    //   }
    // })
    // .addCase(saveJobAsync.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error?.message || "Failed to add job";
    // })
  },
});

export const selectSavedJob = (state) => state.savedJob.data;

export default SavedJobsSlice.reducer;
